import React from 'react'

const Contactus = () => {
  return (
    <div>
      <h3>Contact Us</h3> 
      
      <b>Last updated on 19-07-2024 08:40:10 </b>
      <b> You may contact us using the information below:</b>
      <p>

        <ul>
            <li>
            Merchant Legal entity name: MONU DIXIT 
            </li>
            <li>
            Registered Address: Hno 645 saraswati vihar, gurgao, Haryana, PIN: 122002
            </li>
            <li>
            Operational Address: Hno 645 saraswati vihar, gurgao, Haryana, PIN: 122002
            </li>
            <li>
            Telephone No: 8377840464
            </li>
            <li>
            E-Mail ID: monudixit0007@gmail.com
            </li>
        </ul>
      </p>
      
    </div>
  )
}

export default Contactus
